import { render, staticRenderFns } from "./SpaceGroupRow.vue?vue&type=template&id=e147f858&scoped=true"
import script from "./SpaceGroupRow.vue?vue&type=script&lang=js"
export * from "./SpaceGroupRow.vue?vue&type=script&lang=js"
import style0 from "./SpaceGroupRow.vue?vue&type=style&index=0&id=e147f858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e147f858",
  null
  
)

export default component.exports